import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { DataService } from '../../../Services/DataSharingService';
import { Subscription } from 'rxjs/Subscription';
import { HeaderService } from '../../../Services/HeaderService';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PopupComponent implements OnInit {

  constructor(private _titleService: Title) {
    _titleService.setTitle('Popup');
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/popup/popup.component.ts